function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "checked_inline_svg__Icon_ionic-md-checkmark-circle",
  "data-name": "Icon ionic-md-checkmark-circle",
  d: "M16.388 3.375A13.013 13.013 0 1029.4 16.388 13.052 13.052 0 0016.388 3.375zm-2.671 19.952l-6.669-6.67 1.871-1.871 4.8 4.8L23.865 9.45l1.871 1.871z",
  transform: "translate(-3.375 -3.375)",
  fill: "#02e9b8"
});

function SvgCheckedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.027,
    height: 26.027,
    viewBox: "0 0 26.027 26.027"
  }, props), _ref);
}

export default SvgCheckedinline;